customElements.whenDefined('shopify-forms-embed').then(() => {
  const observer = new MutationObserver(() => {
    const widgets = document.querySelectorAll('shopify-forms-embed');

    widgets.forEach((widget) => {
      // Skip if already processed
      if (widget.dataset.styled) return;

      const shadowRoot = widget.shadowRoot;
      if (!shadowRoot) return;

      const sheet = new CSSStyleSheet();

      sheet.replaceSync(`
        :host {
          --inline-container-max-width: 600px;
          --heading-text-color: var(--color-foreground);
          --body-text-color: var(--color-foreground);
          --form-text-color: var(--color-foreground);
          --form-field-border-radius: var(--style-border-radius-inputs);
          --form-field-border: 0 0 0 1px var(--color-border);
          --button-padding: var(--button-padding-block) var(--button-padding-inline);
          --button-border-radius: var(--style-border-radius-buttons-primary);
        }

        #form-container-ref [class*='formContainer'] {
          margin: 0;
        }

        #form-container-ref form {
          gap: 20px;
          width: 600px;
          max-width: 100%;
          box-sizing: border-box;
        }

        #form-container-ref p,
        #form-container-ref label,
        #form-container-ref input,
        #form-container-ref textarea {
          font-family: var(--font-paragraph--family);
        }

        #form-container-ref h2 {
          margin-bottom: 16px;
          font-family: var(--font-h2--family);
          font-size: var(--font-h2--size);
          line-height: var(--font-h2--line-height);
        }

        #form-container-ref p {
          font-size: 16px;
        }

        #form-container-ref input,
        #form-container-ref textarea {
          font-size: 16px;
        }

        #form-container-ref textarea {
          padding-top: var(--form-field-padding-top);
        }

        #form-container-ref textarea + label {
          margin-top: 3px;
        }

        [class*='formFieldContainer']:has(textarea)::before {
          background: transparent;
        }

        #form-container-ref [class*='selectToggle'] {
          height: 50px;
          max-height: 50px;
        }

        #form-container-ref button[type="submit"] {
          box-shadow: inset 0 0 0 1px var(--button-background-color);
          border-radius: var(--style-border-radius-buttons-primary);
          background-color: var(--button-background-color);
          font-family: inherit;
          font-size: var(--font-paragraph--size);
          line-height: var(--font-paragraph--line-height);
          text-transform: var(--button-text-case-primary);
          font-weight: var(--button-font-weight-primary);
        }

        #form-container-ref [class*='formDisclaimer'] p {
          font-size: 12px;
        }

        [class*='formBannerContainer'] [class*='formBannerHeading'] {
          margin-bottom: 16px;
          font-family: var(--font-h3--family);
          font-style: var(--font-h3--style);
          font-weight: var(--font-h3--weight);
          font-size: var(--font-h3--size);
          line-height: var(--font-h3--line-height);
          letter-spacing: var(--font-h3--letter-spacing);
          text-transform: var(--font-h3--case);
        } 

        [class*='formBannerContainer'] p {
          font-family: var(--font-paragraph--family);
          font-size: 16px;
        } 
      `);

      shadowRoot.adoptedStyleSheets.push(sheet);

      // Mark as processed
      widget.dataset.styled = "true";
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});